/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-31 11:10:09
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-03-31 11:10:39
 * @FilePath: /unifyxp-v2-store-portal/src/layout/Components/index.ts
 */
export { default as PageStructure } from './PageStructure/PageStructure';
export { default as Trigger } from './CollapseTrigger/Trigger';
